export default __webpack_public_path__ + "static/media/7.cbadd8e4.webp";